import cn from 'classnames';
import React from 'react';

import { Space, Typography } from '@sravni/react-design-system';

import { Logo } from '@components/RatingTable/columns/components/Logo/Logo';

import type { CellContext } from '@tanstack/table-core';

import type { ProductRatingItem } from '../../../types/rating';

import styles from './columns.module.scss';

export const makeProductNameColumn = (filters: TFilters) => (info: CellContext<ProductRatingItem, any>) => {
  const { organizationName, organizationLogo, productName, productLogo } = info.row.original;
  const { service } = filters;
  const isCard = ['creditCards', 'debitCards'].includes(service.key);

  return (
    <Space size={8} direction="horizontal" align="center">
      <Logo link={isCard ? productLogo : organizationLogo} isCard={isCard} />
      <Space direction="vertical" size={2}>
        <Typography.Text size={16} strong>
          {productName}
        </Typography.Text>
        <Typography.Text size={10} uppercase strong className={cn('h-color-D60', styles.orgNameForProductNameColumn)}>
          {organizationName}
        </Typography.Text>
      </Space>
    </Space>
  );
};
